<template>
    <div class="flex h-screen bg-gray-900 text-white">
        <!-- Sidebar -->
        <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg">
            <div class="flex items-center justify-center space-x-3">
       <img src="@/assets/logo.svg" alt="Syniac Logo" class="h-20">
            </div>
            <Navbar />
        </aside>

        <!-- Main Content -->
        <div class="flex-1 flex flex-col">
            <!-- Top Navbar -->
            <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md">
                <h2 class="text-xl font-semibold">Nodes</h2>
            </header>

            <!-- Nodes List -->
            <main class="p-6 flex-1 overflow-y-auto">
                <div class="bg-gray-800 p-6 rounded-xl shadow-md">
                    <table class="min-w-full table-auto">
                        <thead>
                            <tr class="bg-gray-700">
                                <th class="px-4 py-2 text-left">Name</th>
                                <th class="px-4 py-2 text-left">ID</th>
                                <th class="px-4 py-2 text-left">Deployed Servers</th>
                                <th class="px-4 py-2 text-left">Rack Info</th>
                                <th class="px-4 py-2 text-left">Location</th>
                                <th class="px-4 py-2 text-left">CPU Usage</th>
                                <th class="px-4 py-2 text-left">RAM Usage</th>
                                <th class="px-4 py-2 text-left">Disk Usage</th>
                                <th class="px-4 py-2 text-left">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="node in nodes" :key="node.id" class="bg-gray-800 hover:bg-gray-700 cursor-pointer" @click="goToNode(node.id)">
                                <td class="px-4 py-2">{{ node.name }}</td>
                                <td class="px-4 py-2">{{ node.id }}</td>
                                <td class="px-4 py-2">{{ node.count }}</td>
                                <td class="px-4 py-2">{{ node.description }}</td>
                                <td class="px-4 py-2">{{ node.location }}</td>
                                <td class="px-4 py-2">{{ node.cpuusage }}%</td>
                                <td class="px-4 py-2">{{ node.ramusage }}%</td>
                                <td class="px-4 py-2">{{ node.diskusage }}%</td>
                                <td class="px-4 py-2">
                                    <span 
                                        class="px-3 py-1 rounded-full text-sm"
                                        :class="node.status === 'Online' ? 'bg-green-500' : 'bg-red-500'">
                                        {{ node.status }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import Navbar from '@/components/adminnav.vue';
import axios from 'axios'

export default {
    name: "ListNodes",
    components: { Navbar },
    data() {
        return {
            nodes: []
        };
    },
    async mounted() {
        await this.fetchNodes();
    },
    methods: {
        async fetchNodes() {
            try {
                const response = await axios.get("https://api.syniac.com:3000/api/admin/node/api/list-nodes", { withCredentials: true });
                this.nodes = response.data;
            } catch (error) {
                console.error("Error fetching nodes:", error);
            }
        },
        goToNode(serverId) {
            this.$router.push(`/admin/edit/${serverId}`);
        },
    }
};
</script>
